import React, { useState, useEffect, Fragment } from "react";
import { Link, withRouter, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Table, Tooltip, Tag, Drawer, notification, Button, Modal } from "antd";
import { ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { toISTDate } from "@Apis/constants";
import Helpers from "@Apis/helpers";
import H3Text from "@Uilib/h3Text";
import PurchaseOrderActions from "@Actions/purchaseOrderActions";
import "./style.scss";
import H3Image from "@Uilib/h3Image";
import closeIcon from "@Images/icons/icon-close-blue.png";
import ViewPurchaseOrder from "@Components/Common/ViewPurchaseOrder";
import MrpV2Actions from "@Actions/production/mrpV2Actions";
import LinkPurchaseOrderMrp from "./LinkPurchaseOrderMrp";
import HideValue from "../../../../Common/RestrictedAccess/HideValue";
import { GetPurchaseOrders } from '@Modules/purchase/purchaseOrder';

function MaterialRequests({
  user,
  getStockItemsShortageLoading,
  pushToProductionItemsLoading,
  pushToStockItemsLoading,
  updateMrpV2Loading,
  match,
  MONEY,
  getPurchaseOrderByIdLoading,
  getPurchaseOrderById,
  mrpData,
  getPurchaseOrdersV2Loading,
  call,
  getStockItems,
  unlinkPoToMrpLoading,
  unlinkPoToMrp,
  getMrpSummary,
  priceMasking,
  getPurchaseOrdersV2,
}) {
  // Stock Items
  const [showLinkPoMrp, setShowLinkPoMrp] = useState(false);
  const [callStockItem, setCallStockItem] = useState(false);
  const [showPurchaseOrder, setShowPurchaseOrder] = useState(false);
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
  const [mrpPurchaseOrders, setMrpPurchaseOrders] = useState(null);
  const [materialShortage, setMaterialShortage] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const location = useLocation();

  const mrpId = match.params?.mrpId;

  const getPoData = () => {
    // getPurchaseOrders(
    //   user?.tenant_info?.org_id,
    //   mrpData?.tenant_id,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   (purchase_orders) => {
    //     setMrpPurchaseOrders(purchase_orders.purchase_order);
    //   },
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   null,
    //   mrpId
    // );
    getPurchaseOrdersV2({
      query: {
        org_id: user?.org_id,
        tenant_id: mrpData?.tenant_id,
        mrp_id: mrpId,
      },
    }, (purchase_orders) => {
      setMrpPurchaseOrders(purchase_orders.purchase_order);
    });
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const processUnlink = ({ free_reserved_batch }) => {
    const payload = {
      mrp_id: mrpData?.mrp_id,
      po_ids: selectedRowKeys,
      free_reserved_batch,
    };
    unlinkPoToMrp(payload, () => {
      setSelectedRowKeys([]);
      setSelectedRows([]);
      setCallStockItem(!callStockItem);
      // setCallProdctionItem(!callProdctionItem);
      setIsModalVisible(false);
      getPoData();
      getMrpSummary({ mrpId: Number(mrpData?.mrp_id) }, () => { });
      // setCallForMO();
    });
  };

  const handleUnlinkPO = () => {
    // Handle unlink PO without freeing batches
    processUnlink({ free_reserved_batch: false });
  };

  const handleUnlinkWithBatches = () => {
    // Handle unlink PO and free batches
    processUnlink({ free_reserved_batch: true });
  };

  useEffect(() => {
    const tab = location.search?.split("=")?.[1];
    if (tab === "materials_requests") {
      setCallStockItem(!callStockItem);
    }
  }, [location.search]);
  useEffect(() => {
    // orgId, tenantId, tenantSellerId, poId, onDate, fromDate, toDate, status, page, limit, roleId, callback, poNumber, searchKeyword, poReceivingStatus, expiryStartDate, expiryEndDate, paymentStatus, edd, productSearch
    getPoData();
    getStockItems({ mrpId: Number(mrpId), entityType: "SHORTAGE" }, (res) => {
      setMaterialShortage(res.data || []);
    });
    return () => {
      // getPurchaseOrdersSuccess(null);
    };
  }, [mrpData, call]);

  function getExpiryStatus(expiryDate) {
    const today = dayjs().startOf("day");
    const expiry = dayjs(expiryDate).startOf("day");
    const daysDifference = Number(expiry.diff(today, "day"));

    if (daysDifference > 7) {
      const weeks = Math.floor(daysDifference / 7);
      return `Expires in ${weeks} week${weeks > 1 ? "s" : ""}`;
    }

    if (daysDifference > 2) {
      return `Expires in ${daysDifference} day${daysDifference > 1 ? "s" : ""}`;
    }

    if (daysDifference === 2) {
      return "Expires in 2 days";
    }

    if (daysDifference === 1) {
      return "Expires Tomorrow";
    }

    if (daysDifference === 0) {
      return "Expires Today";
    }

    if (daysDifference === -1) {
      return "Expired Yesterday";
    }

    if (daysDifference === -2) {
      return "Expired 2 days ago";
    }

    if (daysDifference >= -7) {
      const weeks = Math.abs(Math.floor(daysDifference / 7));
      return `Expired ${weeks} week${weeks > 1 ? "s" : ""} ago`;
    }

    const months = Math.abs(Math.floor(daysDifference / 30));
    return `Expired ${months} month${months > 1 ? "s" : ""} ago`;
  }

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } =
    priceMasking;

  const getMaterialRequestColumns = () => {
    const productListColumns = [
      {
        title: "",
        render: (record) => (
          <Link to={`/approval?type=po&id=${record.po_id}`}>
            <div className="mobile-list__item">
              <div style={{ display: "flex" }}>
                <H3Text
                  text={`#${record?.po_number}`}
                  className="mobile-list__item-number"
                />
                <div
                  className="mobile-list__item-status"
                  style={{
                    backgroundColor: Helpers.getStatusColor(record.status)
                      .color,
                  }}
                >
                  {Helpers.getStatusColor(record.status).text?.toUpperCase()}
                </div>
              </div>
              {record?.seller_info && (
                <div className="mobile-list__item-info">
                  {`Vendor - ${record.seller_info?.seller_name}`}
                </div>
              )}
              <H3Text
                text={`Amount - ${MONEY(record?.po_grand_total || "0", record?.org_currency_info?.currency_code)}`}
                className="mobile-list__item-info"
              />
              <H3Text
                text={
                  <React.Fragment>
                    Receiving Status -&nbsp;
                    <span
                      style={{
                        color: Helpers.getStatusColor(
                          record?.po_receiving_status || "NOT_RECEIVED"
                        ).color,
                      }}
                    >
                      {Helpers.getStatusColor(
                        record?.po_receiving_status || "NOT_RECEIVED"
                      ).text?.toUpperCase()}
                    </span>
                  </React.Fragment>
                }
                className="mobile-list__item-info"
              />
              <H3Text
                text={`Created by ${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : "Unknown"} on ${toISTDate(record?.created_at).format("DD/MM/YYYY")}`}
                className="mobile-list__item-footer"
              />
            </div>
          </Link>
        ),
        responsive: ["xs"],
      },
      {
        title: "Purchase Order#",
        dataIndex: "po_number",
        render: (text, record) => (
          <div className="list__actions">
            <Link to={`/approval?type=po&id=${record.po_id}`}>
              <div className=" list__actions-button">{record?.po_number}</div>
            </Link>
          </div>
        ),
        fixed: "left",
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Vendor",
        render: (text, record) => (
          <Fragment>
            <div
              style={{
                color: "rgb(106, 106, 106)",
                fontWeight: "600",
                fontSize: "12px",
                cursor: "pointer",
              }}
            />
            <div
              style={{
                color: "#2D7DF7",
                fontWeight: "600",
                fontSize: "12px",
                cursor: "pointer",
              }}
              onClick={() =>
                history.push(`/vendors/view/${record?.seller_info?.seller_id}`)
              }
            >
              {record && record.seller_info
                ? `${record?.seller_info?.internal_slr_code ? `${record?.seller_info?.internal_slr_code} - ` : ""}${record.seller_info?.seller_name}`?.trim()
                : ""}
            </div>
            <div>
              {record?.seller_address?.city ? record.seller_address.city : ""}
            </div>
          </Fragment>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Items",
        render: (text, record) => record.purchase_order_lines?.length,
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Amount",
        render: (text, record) =>
          isDataMaskingPolicyEnable && isHideCostPrice ? (
            <HideValue
              showPopOver
              popOverMessage={"You don't have access to view amount"}
            />
          ) : (
            MONEY(
              record.po_grand_total || "0",
              record?.org_currency_info?.currency_code
            )
          ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Created Date",
        render: (text, record) => (
          <div>
            {toISTDate(record?.created_at).format("DD/MM/YYYY")}
            <H3Text
              text={
                record?.created_by_info
                  ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}`
                  : "Unknown"
              }
              className="table-subscript"
            />
          </div>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "PO Date",
        render: (text, record) => (
          <div>{toISTDate(record?.po_date).format("DD/MM/YYYY")}</div>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "Status",
        render: (item) => (
          <div
            className="qr__status"
            style={{
              backgroundColor: Helpers.getStatusColor(item.status).color,
            }}
          >
            {Helpers.getStatusColor(item.status).text}
          </div>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      // {
      //   title: 'EXPIRY STATUS',
      //   render: (item) => (
      //
      //     <Tooltip
      //       title={toISTDate(item?.po_expiry_date).format('DD/MM/YYYY')}
      //       placement="topLeft"
      //       style={{ cursor: 'pointer' }}
      //     >
      //       {item?.po_expiry_date != null && (
      //         <Tag icon={<ExclamationCircleOutlined />} color={getExpiryStatus(item?.po_expiry_date)?.includes('Expires Today') ? 'warning' : getExpiryStatus(item?.po_expiry_date)?.includes('Expired') ? 'error' : 'green'}>
      //           {getExpiryStatus(item?.po_expiry_date)}
      //
      //         </Tag>
      //       )}
      //
      //     </Tooltip>
      //
      //   ),
      //   responsive: ['sm', 'md', 'lg', 'xxl'],
      // },
      {
        title: "Receiving Status",
        render: (item) => (
          <Fragment>
            <div
              style={{
                color: Helpers.getStatusColor(
                  item?.po_receiving_status || "NOT_RECEIVED"
                ).color,
              }}
            >
              {Helpers.getStatusColor(
                item?.po_receiving_status || "NOT_RECEIVED"
              ).text?.toUpperCase()}
            </div>
            {item?.closing_status === "CLOSED" && (
              <div className="po-short-closed-tag">Closed</div>
            )}
          </Fragment>
        ),
        responsive: ["sm", "md", "lg", "xxl"],
      },
      {
        title: "",
        key: "action",
        render: (text, record) => (
          <div className="list__actions">
            <div
              className="list__actions-button list__actions-button-dark"
              style={{ width: "70px", whiteSpace: "nowrap" }}
              // onClick={() => {
              //   setSelectedPurchaseOrder(record?.po_id);
              //   if (!getPurchaseOrderByIdLoading) {
              //     getPurchaseOrderById(record?.po_id, record?.tenant_id, () => {
              //       setShowPurchaseOrder(true);
              //     });
              //   }
              // }}
              onClick={() =>
                window.open(`/approval?type=po&id=${record?.po_id}`)
              }
            >
              {getPurchaseOrderByIdLoading &&
              selectedPurchaseOrder === record?.po_id ? (
                <LoadingOutlined />
              ) : (
                "View"
              )}
            </div>
          </div>
        ),
        fixed: "right",
        responsive: ["sm", "md", "lg", "xxl"],
        className: "list__actions-column",
      },
    ].filter((item) => item.hidden !== true);
    return productListColumns;
  };

  return (
    <Fragment>
      <Drawer
        width="1080px"
        title="Basic Drawer"
        placement="right"
        onClose={() => setShowLinkPoMrp(false)}
        open={showLinkPoMrp}
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
            style={{
              position: "static",
              width: "1035px",
            }}
          >
            <H3Text
              text="Link Production Orders to this Materials Plan"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowLinkPoMrp(false)}
            />
          </div>
          <LinkPurchaseOrderMrp
            mrpId={mrpId}
            tenantId={mrpData?.tenant_id}
            mrpData={mrpData}
            materialShortage={materialShortage}
            callback={() => {
              // getPurchaseOrders(
              //   user?.tenant_info?.org_id,
              //   mrpData?.tenant_id,
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   (purchase_orders) => {
              //     setMrpPurchaseOrders(purchase_orders.purchase_order);
              //   },
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   null,
              //   mrpId
              // );
              getPurchaseOrdersV2({
                query: {
                  org_id: user?.org_id,
                  tenant_id: mrpData?.tenant_id,
                  mrp_id: mrpId,
                },
              }, (purchase_orders) => {
                setMrpPurchaseOrders(purchase_orders.purchase_order);
              });
              setShowLinkPoMrp(false);
              getMrpSummary({ mrpId: Number(mrpData?.mrp_id) }, () => { });
            }}
          />
        </div>
      </Drawer>
      <Modal
        title="Remove purchase Orders"
        open={isModalVisible}
        onCancel={handleCancel}
        closable
        footer={false}
      >
        <p>
          Do you also want to free reserved batches for selected purchase
          orders?
        </p>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <Button
            key="unlink"
            onClick={handleUnlinkPO}
            disabled={unlinkPoToMrpLoading}
            style={{ marginBottom: "10px" }}
          >
            Remove Without Clearing Reservations
          </Button>
          <Button
            key="unlinkBatch"
            onClick={handleUnlinkWithBatches}
            type="primary"
            disabled={unlinkPoToMrpLoading}
            style={{ marginBottom: "10px" }}
          >
            Remove and Clear Reservations
          </Button>
          <Button
            key="back"
            onClick={handleCancel}
            disabled={unlinkPoToMrpLoading}
          >
            Cancel
          </Button>
        </div>
      </Modal>
      <div className="material-requests__wrapper">
        <div className="material-requests__lower-wrapper">
          <div className="material-requests__table">
            {/* <div className="material-requests__table-buttons">
              <Button
                type="primary"
                onClick={() => {
                  setShowLinkPoMrp(true);
                }}
                customClass="material-requests__table__add-button"
                disabled={!(materialShortage?.length >= 1)}
              >
                Link Purchase Orders
              </Button>
              &nbsp;
              &nbsp;
              <Button
                onClick={showModal}
                disabled={selectedRows?.length === 0}
                danger
              >
                Unlink Production Orders
              </Button>
            </div> */}
            <Table
              // title={() => (
              //   <div className="material-requests__table-title__wrapper">
              //     <div className="material-requests__table-title">
              //       <H3Text text={purchaseOrders?.count || '0'} className="material-requests__table-title-count" />
              //       <span>&nbsp;Purchase Orders</span>
              //     </div>
              //   </div>
              // )}
              bordered
              loading={
                getPurchaseOrdersV2Loading ||
                getStockItemsShortageLoading ||
                pushToProductionItemsLoading ||
                pushToStockItemsLoading ||
                updateMrpV2Loading
              }
              showHeader
              size="small"
              scroll={{ x: "max-content" }}
              columns={getMaterialRequestColumns()}
              dataSource={mrpPurchaseOrders || []}
              rowKey="po_id"
              rowSelection={
                window.screen.width > 425
                  ? {
                      onChange: (rowKeys, rows) => {
                        setSelectedRowKeys(rowKeys);
                        setSelectedRows(rows);
                      },
                      selectedRowKeys,
                    }
                  : false
              }
              pagination={false}
            />
          </div>
        </div>
      </div>
      <Drawer
        onClose={() => {
          setShowPurchaseOrder(false);
        }}
        open={showPurchaseOrder}
        width="1140px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: "1095px" }}>
            <H3Text
              text="View Purchase Order"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowPurchaseOrder(false);
              }}
            />
          </div>
        </div>
        <ViewPurchaseOrder
          isQuickView
          selectedPurchaseOrder={selectedPurchaseOrder}
          handleClose={() => {
            setShowPurchaseOrder(false);
            setCallStockItem(!callStockItem);
            getPoData();
          }}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers,
  MrpV2Reducers,
  PurchaseOrderReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  getLinkedMOLoading: MrpV2Reducers.getLinkedMOLoading,
  pushToProductionItemsLoading: MrpV2Reducers.pushToProductionItemsLoading,
  getStockItemsShortageLoading: MrpV2Reducers.getStockItemsShortageLoading,
  pushToStockItemsLoading: MrpV2Reducers.pushToStockItemsLoading,
  updateMrpV2Loading: MrpV2Reducers.updateMrpV2Loading,
  unlinkPoToMrpLoading: MrpV2Reducers.unlinkPoToMrpLoading,
  linkedMO: MrpV2Reducers.linkedMO,
  stockItemsShortage: MrpV2Reducers.stockItemsShortage,
  updateMrpProductionLoading: MrpV2Reducers.updateMrpProductionLoading,
  getMrpV2Loading: MrpV2Reducers.getMrpV2Loading,
  mrpV2: MrpV2Reducers.mrpV2,
  getPurchaseOrderByIdLoading:
    PurchaseOrderReducers.getPurchaseOrderByIdLoading,
  priceMasking: UserReducers.priceMasking,
  purchaseOrdersV2: GetPurchaseOrders.data,
  getPurchaseOrdersV2Loading: GetPurchaseOrders.loading,
});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseOrderById: (poId, tenantId, callback) =>
    dispatch(
      PurchaseOrderActions.getPurchaseOrderById(poId, tenantId, callback)
    ),
  getStockItems: (payload, callback) =>
    dispatch(MrpV2Actions.getStockItems(payload, callback)),
  unlinkPoToMrp: (payload, callback) =>
    dispatch(MrpV2Actions.unlinkPoToMrp(payload, callback)),
  getMrpSummary: (payload, callback) =>
    dispatch(MrpV2Actions.getMrpSummary(payload, callback)),
  getPurchaseOrdersV2: (payload, callback) => dispatch(GetPurchaseOrders.actions.request(payload, callback)),
});

MaterialRequests.propTypes = {
  user: PropTypes.any,
  getStockItems: PropTypes.func,
  getStockItemsShortageLoading: PropTypes.bool,
  pushToProductionItemsLoading: PropTypes.bool,
  pushToStockItemsLoading: PropTypes.bool,
  updateMrpV2Loading: PropTypes.bool,
  match: PropTypes.any,
  getPurchaseOrdersSuccess: PropTypes.func,
  MONEY: PropTypes.any,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MaterialRequests));
